import _classCallCheck from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { createEditor, DecoratorNode } from "lexical";
import * as React from "react";
import { Suspense } from "react";
var ImageComponent = /*#__PURE__*/React.lazy(
// @ts-ignore
function () {
  return import("./ImageComponent");
});
function convertImageElement(domNode) {
  if (domNode instanceof HTMLImageElement) {
    var altText = domNode.alt,
      src = domNode.src,
      height = domNode.height,
      width = domNode.width;
    var _node = $createImageNode({
      altText: altText,
      src: src,
      height: height,
      width: width,
      captionsEnabled: false,
      showCaption: false
    });
    return {
      node: _node
    };
  }
  return null;
}
export var ImageNode = /*#__PURE__*/function (_DecoratorNode) {
  _inherits(ImageNode, _DecoratorNode);
  var _super = _createSuper(ImageNode);
  function ImageNode(src, altText, maxWidth, width, height, showCaption, caption, captionsEnabled, key) {
    var _this;
    _classCallCheck(this, ImageNode);
    _this = _super.call(this, key);
    _this.__src = src;
    _this.__altText = altText;
    _this.__maxWidth = maxWidth;
    _this.__width = width || "inherit";
    _this.__height = height || "inherit";
    _this.__showCaption = showCaption || false;
    _this.__caption = caption || createEditor();
    _this.__captionsEnabled = captionsEnabled || captionsEnabled === undefined;
    return _this;
  }
  _createClass(ImageNode, [{
    key: "exportDOM",
    value: function exportDOM() {
      var element = document.createElement("img");
      element.setAttribute("src", this.__src);
      element.setAttribute("alt", this.__altText);
      element.setAttribute('width', this.__width.toString());
      element.setAttribute('height', this.__height.toString());
      return {
        element: element
      };
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return {
        altText: this.getAltText(),
        caption: this.__caption.toJSON(),
        height: this.__height === "inherit" ? 0 : this.__height,
        maxWidth: this.__maxWidth,
        showCaption: this.__showCaption,
        src: this.getSrc(),
        type: "image",
        version: 1,
        width: this.__width === "inherit" ? 0 : this.__width
      };
    }
  }, {
    key: "setWidthAndHeight",
    value: function setWidthAndHeight(width, height) {
      var writable = this.getWritable();
      writable.__width = typeof width === "number" ? Math.floor(width) : width;
      writable.__height = typeof height === "number" ? Math.floor(height) : height;
    }
  }, {
    key: "setShowCaption",
    value: function setShowCaption(showCaption) {
      var writable = this.getWritable();
      writable.__showCaption = showCaption;
    }

    // View
  }, {
    key: "createDOM",
    value: function createDOM(config) {
      var span = document.createElement("span");
      var theme = config.theme;
      var className = theme.image;
      if (className !== undefined) {
        span.className = className;
      }
      return span;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return false;
    }
  }, {
    key: "getSrc",
    value: function getSrc() {
      return this.__src;
    }
  }, {
    key: "getAltText",
    value: function getAltText() {
      return this.__altText;
    }
  }, {
    key: "decorate",
    value: function decorate() {
      return /*#__PURE__*/React.createElement(Suspense, {
        fallback: null
      }, /*#__PURE__*/React.createElement(ImageComponent, {
        src: this.__src,
        altText: this.__altText,
        width: this.__width,
        height: this.__height,
        maxWidth: this.__maxWidth,
        nodeKey: this.getKey(),
        showCaption: this.__showCaption,
        caption: this.__caption,
        captionsEnabled: this.__captionsEnabled,
        resizable: true
      }));
    }
  }], [{
    key: "getType",
    value:
    // Captions cannot yet be used within editor cells

    function getType() {
      return "image";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new ImageNode(node.__src, node.__altText, node.__maxWidth, node.__width, node.__height, node.__showCaption, node.__caption, node.__captionsEnabled, node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(serializedNode) {
      var altText = serializedNode.altText,
        height = serializedNode.height,
        width = serializedNode.width,
        maxWidth = serializedNode.maxWidth,
        caption = serializedNode.caption,
        src = serializedNode.src,
        showCaption = serializedNode.showCaption;
      var node = $createImageNode({
        altText: altText,
        height: height,
        maxWidth: maxWidth,
        showCaption: showCaption,
        src: src,
        width: width
      });
      var nestedEditor = node.__caption;
      var editorState = nestedEditor.parseEditorState(caption.editorState);
      if (!editorState.isEmpty()) {
        nestedEditor.setEditorState(editorState);
      }
      return node;
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        img: function img(node) {
          return {
            conversion: convertImageElement,
            priority: 0
          };
        }
      };
    }
  }]);
  return ImageNode;
}(DecoratorNode);
export function $createImageNode(_ref) {
  var altText = _ref.altText,
    height = _ref.height,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 500 : _ref$maxWidth,
    captionsEnabled = _ref.captionsEnabled,
    src = _ref.src,
    width = _ref.width,
    showCaption = _ref.showCaption,
    caption = _ref.caption,
    key = _ref.key;
  return new ImageNode(src, altText, maxWidth, width, height, showCaption, caption, captionsEnabled, key);
}
export function $isImageNode(node) {
  return node instanceof ImageNode;
}